<template>
  <div>
    <h3>General description</h3>
    <p>
      The constellation simulation mission computes the ephemerides of each
      spacecraft of a constellation, thanks to precise numerical propagation.
      These ephemerides are used to build timelines of visibility events
      concerning spacecrafts, points of interest and ground stations.
    </p>
  </div>
</template>

<script>
export default {
  name: 'tooltipNumericalConstellationSimulationMission'
}
</script>
